const ths = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortable: true,
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name',
    sortable: true,
    sortableId: 'participantPerson.firstName'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name',
    sortable: true,
    sortableId: 'participantPerson.lastName'
  },
  {
    id: 4,
    label: 'Level',
    intlKey: 'table.level',
    sortableId: 'award.awardLevel.value'
  },
  {
    id: 5,
    label: 'Activity Type',
    intlKey: 'table.activity_type',
    sortable: true,
    sortableId: 'residentialProject.activityCategory.parent.id'
  },
  {
    id: 6,
    label: 'Activity',
    intlKey: 'table.activity',
    sortable: true,
    sortableId: 'residentialProject.activityCategory.id'
  },
  {
    id: 7,
    label: 'Goal',
    intlKey: 'table.goal',
    sortable: true,
    sortableId: 'residentialProject.goal'
  },
  {
    id: 8,
    label: 'Assessor',
    intlKey: 'table.assessor',
    sortableId: 'residentialProject.assessorName'
  },
  {
    id: 9,
    label: 'Action',
    intlKey: 'table.action',
    sortable: false
  }
]

export default ths
